'use client'

import * as LucideIcons from 'lucide-react'
import type { LucideProps } from 'lucide-react'

interface DynamicIconProps extends LucideProps {
  name: string
}

/**
 * Renders a Lucide icon dynamically by name
 * @example <DynamicIcon name="Rocket" className="w-6 h-6 text-brand-gold" />
 */
export function DynamicIcon({ name, ...props }: DynamicIconProps) {
  // Get the icon component from lucide-react
  const IconComponent = (
    LucideIcons as unknown as Record<string, React.ComponentType<LucideProps>>
  )[name]

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in lucide-react`)
    return null
  }

  return <IconComponent {...props} />
}
